export function clamp(v) {
    return Math.max(0, Math.min(255, v));
}

export function hexToRgb(hex) {
    const n = hex.replace("#", "")
    return {
        r: parseInt(n.slice(0, 2), 16),
        g: parseInt(n.slice(2, 4), 16),
        b: parseInt(n.slice(4, 6), 16),
    }
}

export function rgbToHex({r, g, b}) {
    return (
        "#" +
        [r, g, b]
            .map(v => clamp(Math.round(v)).toString(16).padStart(2, "0"))
            .join("")
    )
}

export function lightenColorHex(hex, amount = 0.25) {
    const {r, g, b} = hexToRgb(hex)
    return rgbToHex({
        r: r + (255 - r) * amount,
        g: g + (255 - g) * amount,
        b: b + (255 - b) * amount,
    })
}

export function darkenColorHex(hex, amount = 0.25) {
    const {r, g, b} = hexToRgb(hex)
    return rgbToHex({
        r: r * (1 - amount),
        g: g * (1 - amount),
        b: b * (1 - amount),
    })
}

export const DONUT_PALETTE = {
    GRADIENTS: {
        GREEN: ["#47af5b", "#96b44a"],
        YELLOW: ["#ffdc01", "#fdad01"],
        ORANGE: ["#fd8701", "#fd5901"],
        RED: ["#f73b01", "#f7017c"],
        PURPLE: ["#9469c0", "#b769c0"],
        BLUE: ["#647bd7", "#733bff"],
        WHITE: ["#ffffff", "#c7c7c7"],
        GRAY: ["#464646", "#7a7a7a"],
    }
}

export const DONUT_STANDARD_COLORS = [
    DONUT_PALETTE.GRADIENTS.YELLOW,
    DONUT_PALETTE.GRADIENTS.ORANGE,
    DONUT_PALETTE.GRADIENTS.RED,
    DONUT_PALETTE.GRADIENTS.GREEN,
    DONUT_PALETTE.GRADIENTS.PURPLE,
    DONUT_PALETTE.GRADIENTS.BLUE,
    DONUT_PALETTE.GRADIENTS.WHITE,
    DONUT_PALETTE.GRADIENTS.GRAY,
]

export const DONUT_DUAL_VALUES_COLORS = [
    DONUT_PALETTE.GRADIENTS.GREEN,
    DONUT_PALETTE.GRADIENTS.PURPLE,
]

export const getSliceColors = (colors, i, isSliceHovered, isChartHovered) => {

    const palette = colors[i % colors.length]
    let baseColor = palette[0]
    let lightColor = palette[1] || lightenColorHex(baseColor, .25)
    const fontColor = darkenColorHex(baseColor, 0.65)

    if (!isSliceHovered && isChartHovered) {
        baseColor = darkenColorHex(baseColor, .45)
        lightColor = darkenColorHex(baseColor, .35)
    }

    return {
        baseColor,
        lightColor,
        fontColor,
    }

}